// src/msalInstance.js

import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';

// Initialize a single MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

export default msalInstance;
